import React from "react"
import styled from "styled-components"
import Select from "react-select"
import { withRouter } from "react-router-dom"
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle, Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap"
import PropTypes from "prop-types"
import { AvField, AvForm } from "availity-reactstrap-validation"

const MODAL_TYPE = {
  RENAME: "rename",
  CREATE: "create",
  DELETE: "delete"
}

class ReportingTemplates extends React.Component {

  state = {
    isOpenMenu: false,
    modalType: null
  }

  toggleMenu = () => this.setState({ isOpenMenu: !this.state.isOpenMenu })

  componentDidMount() {
    console.log(this.props)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  onSave = () => {
    this.props.onSave()
  }

  onChange = e => {
    this.props.onChange(this.props.options.find(i => i.id === e.value))
  }

  onSubmitForm = (e, errors, params) => {
    console.log({ e, errors, params })
    if (errors.length > 0) return void 0

    const { name } = params

    switch (this.state.modalType) {
      case MODAL_TYPE.RENAME:
        this.props.onSave({name})
        break
      case MODAL_TYPE.CREATE:
        this.props.onCreate({name})
        break
      default:
        return;
    }
    this.setState({modalType: null})
  }

  onDelete = () => {
    this.props.onDelete()
    this.setState({modalType: null})
  }

  render() {
    const { options } = this.props
    const { isOpenMenu, modalType } = this.state

    const value = {
      value: this.props.value,
      label: options.find(i => i.id === this.props.value)?.name
    }

    const isVisibleMore = this.props.value >= 0

    return (
      <ReportingTemplatesStyled>
        <Modal isOpen={modalType} autoFocus={true} centered={true} toggle={() => this.setState({ modalType: false })}>
          <ModalHeader tag="h4">{modalType === MODAL_TYPE.DELETE ? "Delete template" : modalType === MODAL_TYPE.RENAME ? "Rename template" : "Create template"}</ModalHeader>
          <ModalBody>
            {modalType && modalType !== MODAL_TYPE.DELETE ? <AvForm className="needs-validation" onSubmit={this.onSubmitForm}>
              <Row form>
                <Col className="col-12">
                  <div className="mb-3">
                    <AvField
                      name="name"
                      label="Template name"
                      type="text"
                      defaultValue={modalType === "rename" ? value.label : ""}
                      validate={{ required: { value: true } }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-end">
                    <button type="submit" className="btn btn-success save-user">
                      Save changes
                    </button>
                  </div>
                </Col>
              </Row>
            </AvForm>
              : <>
                {modalType && <Row>
                  <Col className="col-12">
                    <p>{`Are you sure want to delete view ${value.label}?`}</p>
                  </Col>
                  <Col className="col-12">
                    <div className="text-end">
                      <button type="submit" className="btn btn-outline-secondary save-user me-2"
                              onClick={() => this.setState({ modalType: null })}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-danger save-user" onClick={this.onDelete}>
                        Delete
                      </button>
                    </div>
                  </Col>
                </Row>}
              </>
            }
          </ModalBody>
        </Modal>
        <div className="reporting-template-select-container">
          <Select
            options={options.map(i => ({ label: i.name, value: i.id })) || []}
            value={value.label ? value : undefined}
            onChange={this.onChange}
            classNamePrefix="select2-selection"
          />
        </div>
        <div className="d-flex align-items-center">
          <Button
            color="success"
            onClick={isVisibleMore ? this.onSave : () => this.setState({modalType: MODAL_TYPE.CREATE})}
          >
            {isVisibleMore ? "Save" : "Save as"}
          </Button>
          {isVisibleMore && <DropdownStyled
            className={""}
            isOpen={this.state.isOpenMenu}
            style={{ width: "100%" }}
            toggle={this.toggleMenu}
          >
            <DropdownToggle outline className=" d-flex align-items-center border-0 bg-transparent ms-2"><i
              className="fas fa-ellipsis-h font-size-20" /></DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={() => this.setState({ modalType: MODAL_TYPE.CREATE })}>Save as</DropdownItem>
              <DropdownItem onClick={() => this.setState({ modalType: MODAL_TYPE.RENAME })}>Rename</DropdownItem>
              <DropdownItem divider />
              <DropdownItem className="text-danger" onClick={() => this.setState({ modalType: MODAL_TYPE.DELETE })}>Delete</DropdownItem>
            </DropdownMenu>
          </DropdownStyled>}
        </div>
      </ReportingTemplatesStyled>
    )
  }
}

ReportingTemplates.propTypes = {
  history: PropTypes.any,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
}

const DropdownStyled = styled(Dropdown)`
  .btn {
    &:hover {
      color: #74788d;
    }
  }

  .dropdown-menu-right {
    right: 0 !important;
    left: initial !important;
    margin-top: 7px;
  }
`

const ReportingTemplatesStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  .reporting-template-select-container {
    width: 300px;
    z-index: 5;
  }

`

export default withRouter(ReportingTemplates)
